import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import GNBSearchInput from "@/components/common/GNB/components/GNBSearchInput";
import { SEARCH_UI_MARKER_PROPS } from "@/components/common/GNB/constants/searchMarker";
import { useSearchDialog } from "@/components/common/GNB/hooks/useSearchDialog";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import { cn } from "@/lib/utils";
import { Icon, Typography } from "@bookips/sds";
import { AnimatePresence, motion } from "framer-motion";
import { useMemo } from "react";
import { purchasableSubjectsList } from "../../api/product";
/**
 * 전체화면 검색 추천 다이얼로그 컴포넌트
 * 1080px 미만 (모바일/태블릿)에서 사용
 */ export const SearchRecommendFullscreenDialog = ()=>{
    const { isOpen , close , searchTerm , setSearchTerm , clearSearchTerm , submit , subject , setSubject , recommendList , onRecommendSelect  } = useSearchDialog();
    const hasRecommendSearchTerm = useMemo(()=>{
        return (recommendList === null || recommendList === void 0 ? void 0 : recommendList.terms) && recommendList.terms.length > 0;
    }, [
        recommendList
    ]);
    const subjects = purchasableSubjectsList();
    const handleTabChange = (newSubject)=>{
        setSubject(newSubject);
        mixpanelEvent("Tab UI Clicked", {
            "Tab Type": "Search Modal Fullscreen",
            "Tab Name": newSubject
        });
    };
    const handleKeywordClick = (keyword, idx)=>{
        mixpanelEvent("Search Keyword Clicked", {
            "Button Name": keyword,
            Subject: subject,
            "Keyword Order": idx + 1,
            "Placeholder Text": recommendList === null || recommendList === void 0 ? void 0 : recommendList.placeHolder
        });
        onRecommendSelect(keyword);
    };
    return /*#__PURE__*/ _jsx(AnimatePresence, {
        children: isOpen && /*#__PURE__*/ _jsxs(motion.div, {
            initial: {
                opacity: 0
            },
            animate: {
                opacity: 1
            },
            exit: {
                opacity: 0
            },
            transition: {
                duration: 0.2
            },
            ...SEARCH_UI_MARKER_PROPS,
            className: "fixed inset-0 z-[9999] bg-white flex flex-col",
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "flex items-center gap-2 px-4 py-3 ",
                    children: [
                        /*#__PURE__*/ _jsx("button", {
                            type: "button",
                            onClick: close,
                            className: "p-2 -ml-2 rounded-md hover:bg-gray-50 transition-colors shrink-0",
                            "aria-label": "닫기",
                            children: /*#__PURE__*/ _jsx(Icon.ArrowLeft_2px, {
                                className: "size-6"
                            })
                        }),
                        /*#__PURE__*/ _jsx(GNBSearchInput, {
                            value: searchTerm,
                            onChange: (e)=>setSearchTerm(e.target.value),
                            onClear: clearSearchTerm,
                            onSubmit: submit,
                            selectedSubject: subject,
                            onSubjectChange: setSubject,
                            placeholder: recommendList === null || recommendList === void 0 ? void 0 : recommendList.placeHolder,
                            isActive: true,
                            autoFocus: true,
                            className: "flex-1"
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "border-b border-gray-100 shrink-0",
                    children: /*#__PURE__*/ _jsx("div", {
                        className: "flex items-center justify-center max-w-[440px] mx-auto overflow-x-auto max-sm:max-w-full",
                        children: subjects.map((tab)=>{
                            const isSelected = subject === tab.key;
                            return /*#__PURE__*/ _jsx("button", {
                                type: "button",
                                onClick: ()=>handleTabChange(tab.key),
                                className: cn("flex-1 px-4 py-3 text-center transition-colors", "border-b-2", isSelected ? "text-gray-900 border-gray-900 font-semibold" : "text-gray-500 border-transparent hover:text-gray-700"),
                                children: /*#__PURE__*/ _jsx(Typography, {
                                    variant: "subtitle2",
                                    children: tab.label
                                })
                            }, tab.key);
                        })
                    })
                }),
                hasRecommendSearchTerm && /*#__PURE__*/ _jsxs("section", {
                    className: "flex-1 overflow-y-auto px-5 py-6 flex flex-col gap-3 w-full max-w-[440px] mx-auto ",
                    children: [
                        /*#__PURE__*/ _jsx(Typography, {
                            variant: "subtitle2",
                            className: "text-gray",
                            children: "쏠북 인기 검색어"
                        }),
                        /*#__PURE__*/ _jsx("ul", {
                            className: "flex flex-wrap gap-2",
                            children: recommendList === null || recommendList === void 0 ? void 0 : recommendList.terms.map((item, idx)=>/*#__PURE__*/ _jsx("li", {
                                    children: /*#__PURE__*/ _jsxs("button", {
                                        type: "button",
                                        onClick: ()=>handleKeywordClick(item, idx),
                                        className: cn("inline-flex items-center gap-1 px-3 py-2 rounded-md", "border border-gray-200", "hover:bg-gray-100", "transition-colors"),
                                        children: [
                                            /*#__PURE__*/ _jsx(Typography, {
                                                variant: "subtitle2",
                                                className: "text-secondary-main",
                                                children: "#"
                                            }),
                                            /*#__PURE__*/ _jsx(Typography, {
                                                variant: "subtitle2",
                                                className: "text-primary",
                                                children: item
                                            })
                                        ]
                                    })
                                }, idx))
                        })
                    ]
                }),
                !hasRecommendSearchTerm && /*#__PURE__*/ _jsx("div", {
                    className: "flex-1 flex items-center justify-center py-10",
                    children: /*#__PURE__*/ _jsx(Typography, {
                        variant: "body2",
                        className: "text-gray-500",
                        children: "추천 검색어가 없습니다"
                    })
                })
            ]
        }, "search-fullscreen-dialog")
    });
};
